import React, { Component } from "react";

export const Loading = ({color}) => (
  <div className="d-flex justify-content-center">
    <div className="spinner-border" style={{color: color ? color : ""}} role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);
